<template>
  <div class="pa-4">
    <p class="font-weight-bold text-center body-2 text-uppercase">
      {{ title }}
    </p>
    <LineChartGenerator
      :chart-options="chartOptions"
      :chart-data="dataChart"
      :chart-id="chartId"
      :dataset-id-key="datasetIdKey"
      :plugins="plugins"
      :css-classes="cssClasses"
      :styles="styles"
      :width="width"
      :height="height"
    />
  </div>
</template>
<script>
import { Line as LineChartGenerator } from "vue-chartjs/legacy";
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  LineElement,
  LinearScale,
  CategoryScale,
  PointElement,
} from "chart.js";
ChartJS.register(
  Title,
  Tooltip,
  Legend,
  LineElement,
  LinearScale,
  CategoryScale,
  PointElement
);
export default {
  name: "LineChartDashboard",
  components: { LineChartGenerator },
  props: {
    title: { type: String },
    chartId: { type: String, default: "bar-chart" },
    datasetIdKey: { type: String, default: "label" },
    width: { type: Number, default: 300 },
    height: { type: Number, default: 300 },
    cssClasses: { default: "", type: String },
    // styles: { type: Object, default: () => {} },
    plugins: { type: Array, default: () => [] },
    dataChart: { type: Object, default: () => {} },
    legend: {
      type: Boolean,
      default: false,
    },
    scaleY: {
      type: Number,
      default: 200,
    },
  },
  created() {
    this.chartOptions.scales.y.suggestedMax = this.scaleY;
  },
  data() {
    return {
      styles: {
        maxHeight: "300px",
      },
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            display: this.legend,
          },
        },
        scales: {
          x: {
            display: true,
            title: {
              display: true,
            },
          },
          y: {
            type: 'linear',
            display: true,
            title: {
              display: false,
            },
            suggestedMin: 0,
            suggestedMax: 0,
          },
        },
      },
    };
  },
};
</script>
